'use strict';
module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/perform.js
// module id = 88
// module chunks = 13